<template>
  <div class="layout">
    <el-container>
      <el-header ref="headerRef">
        <Header :fixedToTop="$route.path === '/index'" />
      </el-header>
      <el-main ref="mainRef">
        <!-- 判断是否有子路由：有则使用 SubMenuLayout 显示 Tabs，没有则直接显示内容 -->
        <template v-if="hasChildrenRoutes">
          <SubMenuLayout />
        </template>
        <template v-else>
          <div class="main-content">
            <keep-alive>
              <router-view v-if="$route.meta.keepAlive" />
            </keep-alive>
            <router-view v-if="!$route.meta.keepAlive" />
          </div>
        </template>
      </el-main>
    </el-container>
    <RightFixedPage></RightFixedPage>
  </div>
</template>

<script>
import Header from "@/components/common/header/Header";
import SubMenuLayout from "@/components/common/SubMenuLayout";

export default {
  name: "Layout",
  components: {
    Header,
    SubMenuLayout
  },
  computed: {
    // 判断当前路由是否有子路由（用于显示二级菜单 Tabs）
    hasChildrenRoutes() {
      const matched = this.$route.matched;
      if (matched.length < 2) return false;

      // 获取父路由（倒数第二个）
      const parentRoute = matched[matched.length - 2];

      // 直接检查父路由对象的 children 属性
      if (parentRoute.children && parentRoute.children.length > 0) {
        const visibleChildren = parentRoute.children.filter(
          child => !child.meta || child.meta.hiddenInMenu !== true
        );
        return visibleChildren.length > 0;
      }

      // 如果 matched 中没有 children，尝试从 router 配置中查找
      const allRoutes = this.$router.options.routes || [];

      const findRouteByPath = (routes, targetPath) => {
        for (const route of routes) {
          if (route.path === targetPath || route.path === '/' + targetPath) {
            return route;
          }
          if (route.children) {
            const found = findRouteByPath(route.children, targetPath);
            if (found) return found;
          }
        }
        return null;
      };

      const targetRoute = findRouteByPath(allRoutes, parentRoute.path);

      if (targetRoute && targetRoute.children && targetRoute.children.length > 0) {
        const visibleChildren = targetRoute.children.filter(
          child => !child.meta || child.meta.hiddenInMenu !== true
        );
        return visibleChildren.length > 0;
      }

      return false;
    }
  }
};
</script>

<style scoped>
.layout {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background-color: #f0f0f0;
}

.el-header {
  flex: 0 0 auto;
  height: 90px !important;
  padding: 0px !important;
  box-shadow: 0 1px 3px #e9e9e9;
  z-index: 2000;
}

.el-main {
  flex: 1 1 auto;
  padding: 0 !important;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: visible;
}

/* 直接显示的 router-view（没有 SubMenuLayout 时），让页面可以正常滚动 */
.main-content {
  display: block;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
}
</style>
